import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {Component, OnDestroy} from "@angular/core";
import {AccountPaymentSearchModel} from "../account-payment-search.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {Subscription} from "rxjs";
import {FUIStackedPageService} from "@fedeltapointofsale/ui";
import {
    AccountPaymentEditPageComponent,
    AccountPaymentEditParams
} from "../account-payment-edit-page/account-payment-edit-page.component";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {ActionEvent} from "../../../framework/entity/action.event";
import {AccountPaymentEntityModel} from "../account-payment-entity.model";

/**
 * Search for Account Payments. This search screen is expected to be accessed via a StackedPage dialog from the
 * account. The accountId and accountName are needed to be provided as parameters
 */
@Component({
    selector: "wbo-account-payment-search-page",
    templateUrl: "./account-payment-search-page.component.html",
    providers: [provideSearchModel(AccountPaymentSearchModel), provideEntityModel(AccountPaymentEntityModel)]
})
export class AccountPaymentSearchPageComponent extends AbstractSearchPage implements OnDestroy {

    private subscriptions: Subscription = new Subscription();

    editPage = AccountPaymentEditPageComponent;

    accountId: string;
    accountName: string = " ";

    constructor(public searchModel: AccountPaymentSearchModel, private stackedPageService: FUIStackedPageService) {
        super();
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    prepareInitialFilter(): void {
        this.accountId = this.extendedSearchParams.searchParams["accountId"];
        this.searchModel.filter["accountId"] = this.accountId;
        setTimeout(() => {
            this.accountName = this.extendedSearchParams.searchParams["accountName"];
        });
    }

    addNew(actionEvent: ActionEvent): void {
        actionEvent.preventDefault();
        this.subscriptions.add(this.stackedPageService.open(AccountPaymentEditPageComponent, new AccountPaymentEditParams(undefined, EditMode.ADD, this.accountId, this.accountName)).subscribe(() => {
            this.searchModel.search();
        }));
    }

    onEdit(actionEvent: ActionEvent): void {
        actionEvent.preventDefault();
        this.subscriptions.add(this.stackedPageService.open(AccountPaymentEditPageComponent, new AccountPaymentEditParams(actionEvent.data["paymentId"], EditMode.EDIT, this.accountId, this.accountName)).subscribe(() => {
        }, () => {
        }, () => this.searchModel.search()));
    }

}
